import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRootStore from '@store/index';
import { ButtonComponent } from '@vg-constellation/angular-16/button';

@Component({
  selector: 'app-smart-continue',
  templateUrl: './smart-continue.component.html',
  styleUrls: ['./smart-continue.component.scss'],
  standalone: true,
  imports: [NgClass, ButtonComponent],
})
export class SmartContinueComponent {
  @Input()
  isSecondary = false;

  @Input()
  enableContinue: boolean;

  @Input()
  continueButton: string;

  @Input()
  disableNextPageOnContinue = false;

  @Output()
  continueClicked: EventEmitter<string> = new EventEmitter<string>();

  continueButtonId = 'smartContinue';
  @Input('continueButtonId')
  set setConinueButtonId(value: string) {
    this.continueButtonId = value;
  }

  constructor(private globalStore: Store<fromRootStore.State>) {}

  clickNext() {
    this.continueClicked.emit('CLICK');
    if (!this.disableNextPageOnContinue) {
      this.nextPage();
    }
  }

  nextPage() {
    this.globalStore.dispatch(fromRootStore.Next());
  }
}
